import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import common translations
import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';

// Import feature translations
import enAuth from './features/auth/locales/en.json';
import esAuth from './features/auth/locales/es.json';

import enDashboard from './features/dashboard/locales/en.json';
import esDashboard from './features/dashboard/locales/es.json';

import enOrg from './features/org/locales/en.json';
import esOrg from './features/org/locales/es.json';

import enSurvey from './features/survey/locales/en.json';
import esSurvey from './features/survey/locales/es.json';

import enNavigation from './features/navigation/locales/en.json';
import esNavigation from './features/navigation/locales/es.json';

import enParticipants from './features/participants/locales/en.json';
import esParticipants from './features/participants/locales/es.json';

import enReport from './features/report/locales/en.json';
import esReport from './features/report/locales/es.json';

import enGuideline from './features/guideline/locales/en.json';
import esGuideline from './features/guideline/locales/es.json';

import enWellnessCenter from './features/wellness-center/locales/en.json';
import esWellnessCenter from './features/wellness-center/locales/es.json';

// Import participant survey question and content locales
import participantSurveyQuestionsEn from './features/participant-survey/locales/questions_en.json';
import participantSurveyQuestionsEs from './features/participant-survey/locales/questions_es.json';
import participantSurveyQuestionsPt from './features/participant-survey/locales/questions_pt.json';
import participantSurveyQuestionsHt from './features/participant-survey/locales/questions_ht.json';
import participantSurveyContentEn from './features/participant-survey/locales/content_en.json';
import participantSurveyContentEs from './features/participant-survey/locales/content_es.json';
import participantSurveyContentPt from './features/participant-survey/locales/content_pt.json';
import participantSurveyContentHt from './features/participant-survey/locales/content_ht.json';
import participantSurveyQuestionsGu from './features/participant-survey/locales/questions_gu.json';
import participantSurveyContentGu from './features/participant-survey/locales/content_gu.json';
import participantSurveyQuestionsAr from './features/participant-survey/locales/questions_ar.json';
import participantSurveyContentAr from './features/participant-survey/locales/content_ar.json';

// Import adult/employer context-specific overrides
import participantSurveyQuestionsEnAdult from './features/participant-survey/locales/questions_en-adult.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        org: enOrg,
        survey: enSurvey,
        navigation: enNavigation,
        participants: enParticipants,
        report: enReport,
        guideline: enGuideline,
        wellnesscenter: enWellnessCenter,
        participantSurveyQuestions: participantSurveyQuestionsEn,
        participantSurveyContent: participantSurveyContentEn
      },
      es: {
        common: esCommon,
        auth: esAuth,
        dashboard: esDashboard,
        org: esOrg,
        survey: esSurvey,
        navigation: esNavigation,
        participants: esParticipants,
        report: esReport,
        guideline: esGuideline,
        wellnesscenter: esWellnessCenter,
        participantSurveyQuestions: participantSurveyQuestionsEs,
        participantSurveyContent: participantSurveyContentEs
      },
      pt: {
        common: enCommon, // Using English common as fallback for now
        auth: enAuth, // Using English auth as fallback for now
        dashboard: enDashboard, // Using English dashboard as fallback for now
        org: enOrg, // Using English org as fallback for now
        survey: enSurvey, // Using English survey as fallback for now
        navigation: enNavigation, // Using English navigation as fallback for now
        participants: enParticipants, // Using English participants as fallback for now
        report: enReport, // Using English report as fallback for now
        guideline: enGuideline, // Using English guideline as fallback for now
        wellnesscenter: enWellnessCenter, // Using English wellnesscenter as fallback for now
        participantSurveyQuestions: participantSurveyQuestionsPt,
        participantSurveyContent: participantSurveyContentPt
      },
      ht: {
        common: enCommon, // Using English common as fallback for now
        auth: enAuth, // Using English auth as fallback for now
        dashboard: enDashboard, // Using English dashboard as fallback for now
        org: enOrg, // Using English org as fallback for now
        survey: enSurvey, // Using English survey as fallback for now
        navigation: enNavigation, // Using English navigation as fallback for now
        participants: enParticipants, // Using English participants as fallback for now
        report: enReport, // Using English report as fallback for now
        guideline: enGuideline, // Using English guideline as fallback for now
        wellnesscenter: enWellnessCenter, // Using English wellnesscenter as fallback for now
        participantSurveyQuestions: participantSurveyQuestionsHt,
        participantSurveyContent: participantSurveyContentHt
      },
      ar: {
        common: enCommon, // Using English common as fallback for now
        auth: enAuth, // Using English auth as fallback for now
        dashboard: enDashboard, // Using English dashboard as fallback for now
        org: enOrg, // Using English org as fallback for now
        survey: enSurvey, // Using English survey as fallback for now
        navigation: enNavigation, // Using English navigation as fallback for now
        participants: enParticipants, // Using English participants as fallback for now
        report: enReport, // Using English report as fallback for now
        guideline: enGuideline, // Using English guideline as fallback for now
        wellnesscenter: enWellnessCenter, // Using English wellnesscenter as fallback for now
        participantSurveyQuestions: participantSurveyQuestionsAr,
        participantSurveyContent: participantSurveyContentAr
      },
      gu: {
        common: enCommon, // Using English common as fallback for now
        auth: enAuth, // Using English auth as fallback for now
        dashboard: enDashboard, // Using English dashboard as fallback for now
        org: enOrg, // Using English org as fallback for now
        survey: enSurvey, // Using English survey as fallback for now
        navigation: enNavigation, // Using English navigation as fallback for now
        participants: enParticipants, // Using English participants as fallback for now
        report: enReport, // Using English report as fallback for now
        guideline: enGuideline, // Using English guideline as fallback for now
        wellnesscenter: enWellnessCenter, // Using English wellnesscenter as fallback for now
        participantSurveyQuestions: participantSurveyQuestionsGu,
        participantSurveyContent: participantSurveyContentGu
      },
      'en-adult': {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        org: enOrg,
        survey: enSurvey,
        navigation: enNavigation,
        participants: enParticipants,
        report: enReport,
        guideline: enGuideline,
        wellnesscenter: enWellnessCenter,
        participantSurveyQuestions: { ...participantSurveyQuestionsEn, ...participantSurveyQuestionsEnAdult },
        participantSurveyContent: participantSurveyContentEn
      }
    },
    lng: 'en', // default language
    fallbackLng: {
      'en-adult': ['en'],
      'default': ['en']
    },
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n; 